import Component from '../inherited/Component';
import Helpers from '../lib/Helpers';

export default class CartShippingThreshold extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    console.log('CartShippingThreshold');

    const optionsElement = document.querySelector('[data-cart-options]');

    this._options = optionsElement ? JSON.parse(optionsElement.innerHTML).shipping : undefined;

    this._start();
  }

  _start() {
    // I know this isn't the best way to do this, but the side cart doesn't seem available on load

    this._elapsed = 0;
    this.interval = setInterval(() => {
      this._elapsed += 100;

      this._elem = document.querySelector('[data-cart-shipping-threshold]');

      if (this._elem != null || this._elapsed > 5000) {
        clearInterval(this.interval);
        if (this._elem != null) {
          this.mount();
        }
      }
    }, 100);
  }

  mount() {
    if (!this._options || !this._options.shippingEnabled) {
      this._elem.parentNode.remove(this._elem);
      return;
    }

    this._captureComponents();

    this._updateComponentStates();

    document.addEventListener('onCartUpdate', (e) => {
      this._updateComponentStates();
    });
  }

  _captureComponents() {
    const components = {
      image: this._elem.querySelector('.cart-free-shipping__image'),
      link: this._elem.querySelector('.cart-free-shipping__link'),
      noticeText: this._elem.querySelector('.cart-free-shipping__notice'),
      progressBar: this._elem.querySelector('.cart-free-shipping__progress--bar'),
      threshold: this._elem.querySelector('.cart-free-shipping__threshold')
    };

    this._components = components;
  }

  _updateComponentStates() {
    const progress = this._calculateProgress();

    if(!progress.show) {
      this._elem.classList.add('d-none');
    } else {
      this._elem.classList.remove('d-none');
    }

    if (this._components.image && this._options.shippingIcon) {
      this._components.image.setAttribute('src', this._options.shippingIcon);
    } else if(!this._options.shippingIcon) {
      this._components.image.parentNode.remove(this._components.image);
    }

    if (this._components.link && this._options.shippingTitle) {
      this._components.link.innerHTML = this._options.shippingTitle;

      if (this._options.shippingTitleURL) {
        this._components.link.setAttribute('href', this._options.shippingTitleURL);
      }
    }

    if (this._components.noticeText) {
      this._components.noticeText.innerHTML =
        progress.remainingAmount === 0
          ? this._options.shippingReachedMessage
          : this._options.shippingUnderMessage.replace(
              '[x]',
              Helpers.formatMoney(progress.remainingAmount, this._ctx.getState())
            );
    }

    if (this._components.threshold && this._options.shippingThreshold !== undefined) {
      this._components.threshold.innerHTML = Helpers.formatMoney(
        this._options.shippingThreshold * 100,
        this._ctx.getState()
      );
    }

    if(this._components.progressBar) {
      this._components.progressBar.style = `width: ${progress.percentage * 100}%`;
    }

  }

  _calculateProgress() {
    const cart = window.MinimogTheme.Cart.cart;

    const threshold = this._options.shippingThreshold * 100;
    const total = cart.total_price;
    const percentage = total >= threshold ? 1 : total / threshold;

    const progress = {
      remainingAmount: Math.max(0, threshold - total),
      percentage,
      show: cart.item_count > 0
    };

    return progress;
  }
}
